import { getTimestampFromUUID } from "sdk";
import { Show } from "solid-js";
import { useCtx } from "@/app/context";
import { Markdown } from "@/atoms/Markdown";
import { Time } from "@/atoms/Time";
import { ChannelIcon } from "@/avatar/ChannelIcon";
import { useChannel } from "@/contexts/mod";
import { useNavigate } from "@/contexts/router";
import type { ChannelT } from "@/types";

export type DocumentCardProps = {
	thread: ChannelT;
	openInSidebar: boolean;
};

// TODO: don't show message count, last message timestamp
// TODO: show when the document was last edited
// TODO: show people who edited (and/or are currently editing?) the document

export const DocumentCard = (props: DocumentCardProps) => {
	const nav = useNavigate();
	const [_ch, chUpdate] = useChannel();
	const ctx = useCtx();

	const goto = () => {
		ctx.setThreadsView(null);

		if (props.openInSidebar) {
			chUpdate("sidebar_document_id", props.thread.id);
		} else {
			nav(`/thread/${props.thread.id}`);
		}
	};

	return (
		<article
			class="thread menu-thread thread-card"
			data-thread-id={props.thread.id}
			onClick={goto}
			onKeyDown={(e) => e.key === "Enter" && goto()}
		>
			<header class="top">
				<ChannelIcon channel={props.thread} />
				<div class="spacer">{props.thread.name}</div>
				<div class="time">
					Created <Time date={getTimestampFromUUID(props.thread.id)} />
				</div>
			</header>
			<div class="bottom">
				<div class="dim">
					<Show when={!!props.thread.deleted_at}>
						<span class="removed">removed</span> &bull;{" "}
					</Show>
					{props.thread.message_count} message(s) &bull; last msg{" "}
					<Time
						date={getTimestampFromUUID(
							props.thread.last_version_id ?? props.thread.id,
						)}
					/>
				</div>
				<Show when={props.thread.description}>
					{(desc) => <Markdown content={desc()} class="description" />}
				</Show>
			</div>
		</article>
	);
};
